import styled from "styled-components";
import { scarpaGray300 } from "@habitech/shared";

export const Hr = styled.hr`
  height: 1px;
  background-color: ${scarpaGray300};
  border: none;
`;
